import React, {useEffect, useState} from 'react'
import { BackTop } from 'antd';
import './index.less'
import {useHistory} from 'react-router-dom';
const Index = (props) => {
    const history = useHistory()
    const navList = [
        {
            key: 'home',
            name: '首页',
            path:'/index'
        },
        {
            key: 'about-gc',
            name: '关于国诚',
            children: [
                {
                    key: 'about-us',
                    name: '公司简介', // 关于我们
                    path: '/aboutUs'
                },
                {
                    key: 'gc-info',
                    name: '国诚资讯',
                    path: '/gcInfo'
                },
                {
                    key: 'contact-us',
                    name: '联系我们',
                    path: '/contactUs'
                },
            ]
        },
        {
            key: 'product-info',
            name: '产品信息',
            children: [
                {
                    key: 'investment',
                    name: '产品下载',
                    path: '/investment'
                },
                {
                    key: 'product',
                    name: '产品服务',
                    path: '/product'
                },
            ]
        },
        {
            key: 'information',
            name: '观点分析',
            path:"/information"
        },
        {
            key: 'compliance',
            name: '安全合规',
            children: [
                {
                    key: 'qualification',
                    name: '企业资质',
                    path: '/compliance/qualification'
                },
                {
                    key: 'concept',
                    name: '合规理念',
                    path: '/compliance/concept'
                },
                {
                    key: 'notice',
                    name: '用户告知',
                    path: '/compliance/notice'
                },
                {
                    key: 'protection',
                    name: '投教保护',
                    path: '/compliance/protection'
                },
                {
                    key: 'regulations',
                    name: '政策法规',
                    path: '/compliance/regulations'
                },
            ]
        },
    ]
    const pathname = history.location.pathname
    useEffect(()=>{
        document.getElementById('root').scrollTop = 0;
        console.log('scrollTop')
    },[pathname])
    return <>
        <BackTop visibilityHeight={0} target={() => document.getElementById('root')}>
            <div className={'back-top'}></div>
        </BackTop>
        <div id={'header'}>
            <div className={'warp'}>
                <div className={'logo'}>
                    <img src={require('@/assets/images/logo.png')}/>
                </div>
                <div className={'nav-list'}>
                    {
                        navList.map(item => {
                            if (item.children) {
                                return (
                                    <div className="nav-item" key={item.key}>
                                        <div className="parent-menu" style={
                                            item.children.some(subItem => pathname.includes(subItem.path))
                                                ? { color: '#1677FF' }
                                                : {}
                                        }>
                                            {item.name}
                                        </div>
                                        <div className="sub-menus">
                                            {
                                                item.children.map(subItem => (
                                                    <div
                                                        className={`sub-menu ${pathname.includes(subItem.path) ? 'active' : ''}`}
                                                        key={subItem.key}
                                                        onClick={() => {
                                                            history.push({
                                                                pathname: subItem.path
                                                            });
                                                            if (subItem.path.includes('compliance')) {
                                                                window.location.reload();
                                                            }
                                                        }}
                                                    >
                                                        {subItem.name}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div
                                        className={`nav-item ${pathname.includes(item.path) ? 'active' : ''}`}
                                        key={item.key}
                                        onClick={() => {
                                            history.push({
                                                pathname: item.path
                                            });
                                        }}
                                    >
                                        {item.name}
                                    </div>
                                );
                            }
                        })
                    }
                </div>
            </div>
        </div>
        <div className={'header-box'}></div>
        {
            props.children
        }
        <div id="foot">
            <div className={'warp'}>
                <h3>深圳市国诚投资咨询有限公司</h3>
                <p>客服热线：400-0136800 | 投诉电话：021-68620177 |营业地址：上海市浦东新区滨江大道257号陆家嘴滨江中心T1座9楼、10楼、11楼1单元<br/>
                    总部客服热线：400-0136800|总部地址：深圳市福田区梅林街道梅都社区中康路128号卓越梅林中心广场(北区)1号楼902</p>
                <p>工作日：9：00-17：30  <a target={'_blank'} href={'https://beian.miit.gov.cn/#/Integrated/index'}>|粤ICP备08109470号</a> <a target={'_blank'} style={{'paddingLeft':'10px'}} href={'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402005950'}>
                    <img src={require('@/assets/images/ba.png')} />
                    <span>粤公网安备 44030402005950号</span></a>
                </p>
                <p>投资有风险，入市需谨慎</p>
            </div>
        </div>
    </>
}

export default Index
